import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

//pages import
import Messages from "../Private/Messages/Messages.js";

import KatalogAdd from "./Katalog/KatalogAdd.js";
import KatalogView from "./Katalog/KatalogView.js";
import KatalogEdit from "./Katalog/KatalogEdit.js";

function Jodust_panel() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState("katalog-view");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [currentEditId, setCurrentEditId] = useState(null); // za edit
  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      // nema tokena → redirect na login
      navigate("/login");
      return;
    }

    // provera tokena na backend-u
    fetch("http://localhost:5000/api/verify", {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(data => {
        if (!data.ok || data.role !== "admin") {
          // token nije validan ili nije admin
          localStorage.removeItem("token");
          navigate("/login");
        } else {
          setUser(data);
        }
      })
      .catch(err => {
        console.error(err);
        localStorage.removeItem("token");
        navigate("/login");
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading) {
    return <p className="text-center mt-5">Učitavanje...</p>;
  }



  const renderContent = () => {

    switch (page) {

      case "messages":
        return <Messages />;

      case "katalog-view":
        return <KatalogView
          onEdit={(id) => {
            setCurrentEditId(id);  // setuje item koji editujemo
            setPage("katalog-edit"); // prikazuje edit formu
          }}
        />;

      case "katalog-add":
        return <KatalogAdd />;

      case "katalog-edit":
        if (!currentEditId) return <p>Prvo izaberite proizvod za izmenu</p>;
        return <KatalogEdit
          id={currentEditId}
          onBack={() => {
            setPage("katalog-view");
            setCurrentEditId(null);
          }}
        />;

      default:
        return <h3>Admin panel</h3>;
    }
  };

  const active = (name) =>
    page === name ? "btn btn-warning w-100 text-start mb-2" : "btn btn-dark w-100 text-start mb-2";

  return (
    <div className="d-flex">

      {/* SIDEBAR */}
      <div
        style={{
          width: sidebarOpen ? "250px" : "70px",
          transition: "0.3s",
          minHeight: "100vh",
          background: "#1f1f1f",
          color: "white"
        }}
        className="p-3"
      >

        {/* TOGGLE BUTTON */}
        <button
          className="btn btn-sm btn-warning mb-4"
          onClick={() => setSidebarOpen(!sidebarOpen)}
        >
          ☰
        </button>

        {sidebarOpen && <h5 className="mb-4">Admin Panel</h5>}

        {/* MENU */}

        <button
          className={active("messages")}
          onClick={() => setPage("messages")}
        >
          {sidebarOpen ? "Messages" : "📩"}
        </button>


        {sidebarOpen && <p className="mt-3 mb-1 fw-bold">Katalog</p>}

        <button
          className={active("katalog-view")}
          onClick={() => setPage("katalog-view")}
        >
          {sidebarOpen ? "Pregled" : "📄"}
        </button>

        <button
          className={active("katalog-add")}
          onClick={() => setPage("katalog-add")}
        >
          {sidebarOpen ? "Dodaj" : "➕"}
        </button>
        
        <button
          className={active("katalog-edit")}
          onClick={() => setPage("katalog-edit")}
        >
          {sidebarOpen ? "Izmeni" : "✏️"}
        </button>

        {/* LOGOUT */}

        <div className="mt-4">
          <button
            className="btn btn-danger w-100"
            onClick={logout}
          >
            {sidebarOpen ? "Logout" : "⎋"}
          </button>
        </div>

      </div>

      {/* CONTENT */}

      <div className="flex-grow-1 p-4">

        <h2 className="mb-4">
          {user?.role === "admin" ? "Administrator" : ""} Panel
        </h2>

        {renderContent()}

      </div>

    </div>




  );
}

export default Jodust_panel;